import SEOLocaleList from '@apps/components/SEOLocaleList';
import { BASE_URL } from '@apps/config';
import {
  getAllBrandsInitial,
  getNewCarByFilter,
} from '@apps/config/API/new-car.config';
import NewCarScreen from '@apps/screens/NewCar';
import _ from 'lodash';
import { NextPage, NextPageContext } from 'next';
import { useRouter } from 'next/router';
import { NextSeo, NextSeoProps } from 'next-seo';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const Page: NextPage = (props) => {
  const { data, settings, list, webView } = props;
  // ======================= HOOKS
  const router = useRouter();
  // const { t } = useTranslation('common');
  // ======================= STATE

  // ======================= VARIABLES
  const currentUrl = `${BASE_URL}${router?.asPath}`;
  const canonicalPath = currentUrl.split('?')[0].toLowerCase();
  const carBrand = data?.all_brand;
  const newCarLaunch = data.new_car_launch?.slice(0, 12);
  const newCarModels = data.popular_car_models?.slice(0, 8);
  const newCarEV = data.ev_car_models?.slice(0, 12);
  const popularCar = data?.popular_car_models;
  const popularBrand = settings.car_brand_featured;
  const nextSeoProps: NextSeoProps = {
    defaultTitle:
      'All Cars in Malaysia: New Launches, Petrol, EVs, Hybrid Models & Pricing | Carz Automedia Malaysia',
    description:
      'Explore all cars available in Malaysia, including petrol, electric (EV), and hybrid models. Discover detailed specs, reviews, pricing, and upcoming releases on Carz Automedia Malaysia',
    canonical: canonicalPath,
  };

  const settingsList = {
    budget: data.budget_list,
    monthly_payment: data.monthly_payment_list,
    segment: data.car_segment_type_list,
    capacity: data.capacity_list,
    fuel_type: data.fuel_type_list,
    transmission: data.car_variant_transmission_list,
    seat: data.car_seat,
    body_type: settings?.car_body,
  };
  // ======================= VIEWS
  return (
    <>
      {!webView && <NextSeo {...nextSeoProps} />}
      <SEOLocaleList />
      <NewCarScreen
        carBrand={carBrand}
        newCarLaunch={newCarLaunch}
        newCarModels={newCarModels}
        newCarEV={newCarEV}
        popularCar={popularCar}
        popularBrand={popularBrand}
        settings={settingsList}
        filterList={list}
        webView={webView}
      />
    </>
  );
};

/**
 * ===========================
 * SERVER SIDE RENDERING
 * ===========================
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
export async function getServerSideProps(ctx: NextPageContext) {
  const results = await getAllBrandsInitial();
  const query = ctx?.query;
  let filterList = {};
  if (!_.isEmpty(query)) {
    filterList = await getNewCarByFilter?.({ query });
  }
  return {
    props: {
      data: results,
      list: filterList,
    },
  };
}

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default Page;
